'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherDollarSign } from '@subframe/core';
import type { ConfigHibridoApuracao } from '../types';
import { formatarMoedaBR } from '../utils/apuracaoFormatters';
interface ApuracaoBlocoHibridoProps {
  config: ConfigHibridoApuracao;
}
export function ApuracaoBlocoHibrido(t0) {
  const $ = _c(43);
  const {
    config
  } = t0;
  const totalHibrido = config.monthlyBasePrice + config.valorExcedenteTotal;
  let t1;
  if ($[0] !== config.includedUnits || $[1] !== config.unidadesUsadas) {
    t1 = Math.round(config.unidadesUsadas / config.includedUnits * 100);
    $[0] = config.includedUnits;
    $[1] = config.unidadesUsadas;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const percentualUso = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex items-center gap-3"><div className="bg-brand-50 flex h-10 w-10 items-center justify-center rounded-lg"><FeatherDollarSign className="text-brand-600 h-5 w-5" /></div><div><h3 className="text-body-bold font-body-bold text-default-font">Cobrança híbrida (base + uso)</h3><p className="text-caption font-caption text-subtext-color">Valor base mensal somado às unidades excedentes</p></div></div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="text-caption font-caption text-subtext-color">Base mensal</p>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== config.monthlyBasePrice) {
    t4 = formatarMoedaBR(config.monthlyBasePrice);
    $[5] = config.monthlyBasePrice;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <div className="rounded-[12px] bg-neutral-50 p-4">{t3}<p className="text-body-bold font-body-bold text-default-font mt-1">{t4}</p></div>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="text-caption font-caption text-subtext-color">Unidades incluídas</p>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== config.includedUnits || $[11] !== config.unidadesUsadas) {
    t7 = <p className="text-body-bold font-body-bold text-default-font mt-1">{config.unidadesUsadas} / {config.includedUnits}</p>;
    $[10] = config.includedUnits;
    $[11] = config.unidadesUsadas;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== percentualUso) {
    t8 = <p className="text-caption font-caption text-subtext-color mt-0.5">{percentualUso}% usadas</p>;
    $[13] = percentualUso;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <div className="rounded-[12px] bg-neutral-50 p-4">{t6}{t7}{t8}</div>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <p className="text-caption font-caption text-subtext-color">Excedente</p>;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const t11 = config.unidadesExcedentes;
  let t12;
  if ($[19] !== config.overageUnitPrice) {
    t12 = formatarMoedaBR(config.overageUnitPrice);
    $[19] = config.overageUnitPrice;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== config.unidadesExcedentes || $[22] !== t12) {
    t13 = <p className="text-body-bold font-body-bold text-default-font mt-1">{t11} × {t12}</p>;
    $[21] = config.unidadesExcedentes;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== config.valorExcedenteTotal) {
    t14 = formatarMoedaBR(config.valorExcedenteTotal);
    $[24] = config.valorExcedenteTotal;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t14) {
    t15 = <p className="text-warning-700 text-caption font-caption mt-0.5">= {t14}</p>;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t13 || $[29] !== t15) {
    t16 = <div className="rounded-[12px] bg-neutral-50 p-4">{t10}{t13}{t15}</div>;
    $[28] = t13;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t16 || $[32] !== t5 || $[33] !== t9) {
    t17 = <div className="grid grid-cols-1 gap-3 md:grid-cols-3">{t5}{t9}{t16}</div>;
    $[31] = t16;
    $[32] = t5;
    $[33] = t9;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <span className="text-brand-700 text-sm font-medium">Total híbrido do ciclo</span>;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== totalHibrido) {
    t19 = formatarMoedaBR(totalHibrido);
    $[36] = totalHibrido;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t19) {
    t20 = <div className="border-brand-100 bg-brand-50 flex items-center justify-between rounded-[12px] border px-4 py-3">{t18}<span className="text-brand-900 text-lg font-bold">{t19}</span></div>;
    $[38] = t19;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== t17 || $[41] !== t20) {
    t21 = <div className="bg-default-background flex flex-col gap-4 rounded-[16px] border border-solid border-neutral-200 p-6">{t2}{t17}{t20}</div>;
    $[40] = t17;
    $[41] = t20;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  return t21;
}